export default __webpack_public_path__ + "static/bc_hu_6-0fd82f476cf47f8aea25d749a333385c.mp4";